import F84Game from "../Game";
import PlayerData from "../PlayerData";
import LoadingConatiner from "../ui/LoadingContainer";
import BaseURL from "../utils/BaseURL";
import LoaderScene from "./LoaderScene";

export default class PreloaderScene extends LoaderScene {
	private _onResize: () => any;

	private _loadingContainer: LoadingConatiner;
	private _destinationScene: string;
	private _initalLoad: boolean;
	sceneState: any;

	init(data: { destinationScene: string; sceneState?: any; initalLoad?: boolean }): void {
		this._destinationScene = "SplashScene";
		if (data.destinationScene) this._destinationScene = data.destinationScene;
		if (data.sceneState) this.sceneState = data.sceneState;
		else this.sceneState = {};
		this._initalLoad = data.initalLoad ? data.initalLoad : false;
		super.init();
	}

	public preload(): void {
		super.preload();

		this._loadingContainer = new LoadingConatiner(this);
		this.add.existing(this._loadingContainer);

		this.load.setBaseURL(BaseURL.getBaseURL());
		if (this._destinationScene == "GameScene") {
			this.sceneState.levelIndex = PlayerData.Instance.saveData.levelToLoad;
		}
		F84Game.Instance.loadBatches.loadBatchesForScene(this, this._destinationScene);

		this.loadImages("./locale/" + F84Game.Instance.locale + "/", {});

		this.loadUpdate();
	}

	loadUpdate(): void {
		const percentComplete = this.load.totalComplete / this.load.totalToLoad;
		this._loadingContainer.setLoadPercent(percentComplete);
	}

	resize(): void {
		super.resize();
		if (this._onResize != null) this._onResize();
	}

	create(): void {
		super.create();
		this.scene.start(this._destinationScene, this.sceneState);
		this.scene.stop(this.scene.key);
		// ScreenTransition.to(this, this._destinationScene);
	}
}
